<template>
  <div class="service-grid">
    <div
      class="service-item"
      :class="{ active: activeService === 'flights' }"
      @click="goTo('flights')"
    >
      <img src="@/assets/images/plane-white-last.svg" alt="Vuelos" />
      <span>Vuelos</span>
    </div>
    <div
      class="service-item"
      :class="{ active: activeService === 'hotels' }"
      @click="goTo('hotels')"
    >
      <img src="@/assets/images/bed-white-last.svg" alt="Hoteles" />
      <span>Hoteles</span>
    </div>
    <div
      class="service-item"
      :class="{ active: activeService === 'cars' }"
      @click="goTo('cars')"
    >
      <img src="@/assets/icons/car-white-last.svg" alt="Autos" />
      <span>Autos</span>
    </div>
    <div
      class="service-item"
      :class="{ active: activeService === 'transfers' }"
      @click="goTo('transfers')"
    >
      <img src="@/assets/icons/traslado-white-last.svg" alt="Traslados" />
      <span>Traslados</span>
    </div>
    <div
      class="service-item"
      :class="{ active: activeService === 'lounges' }"
      @click="goTo('lounges')"
    >
      <img src="@/assets/icons/vip-white-last.svg" alt="Salas VIP" />
      <span>Salas VIP</span>
    </div>
    <div
      class="service-item"
      :class="{ active: activeService === 'shows' }"
      @click="goTo('shows')"
    >
      <img src="@/assets/icons/espec-white-last.svg" alt="Espectáculos" />
      <span>Espectáculos</span>
    </div>    
  </div>
</template>

<script>
export default {
  name: "ServiceGridComp",
  computed: {
    activeService() {
      // Obtenemos el nombre de la ruta actual para saber qué servicio está activo
      const routeName = this.$route.name || "";
      // Convertimos 'FlightsView' o 'Flights' a 'flights'
      return routeName.toLowerCase().replace("view", "");
    },
  },
  methods: {
    goTo(service) {
      if (service) {
        this.$router.push(`/${service}`);
      }
    },
  },
};
</script>

<style scoped>
.service-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 20px;
  width: 100%;
  max-width: 500px;
  justify-content: center; /* Asegura que la cuadrícula se centre */
  margin: auto;
  position: relative;
  z-index: 2;
}

.service-item {
  background-color: transparent;
  border: 2px solid white;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center; /* Centra el contenido (icono + texto) */
  color: white;
  cursor: pointer;
  transition: background-color 0.3s;
  height: 50px;
}

.service-item.active {
  background-color: var(--color-acento-primario);
  border-color: var(--color-acento-primario); /* Hacemos que el borde coincida con el fondo */
}

.service-item:hover {
  background-color: rgba(
    255,
    255,
    255,
    0.1
  ); /* Efecto sutil al pasar el mouse */
}

.service-item img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}

.service-item span {
  font-size: 0.8rem;
  font-weight: 600;
}
</style>
